// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

import { manipulateCustomJSONOne } from "./methods";

// Actions Import
import PricebooksActions from "../../../actions/PricebooksActions";

// Internal Imports
import FormField from "./FormField";

// Destructuring
const { updatePricebookData, updateFormRowData } = PricebooksActions;

class PricebookItemEditor extends Component {
  componentDidMount() {
    if (
      Object.keys(this.props.formRowData).length === 0 &&
      this.props.formRowData.constructor === Object
    ) {
      const obj = {};
      this.props.customJSON.forEach(item => {
        obj[item.fld] = item.value;
      });
      this.props.updateFormRowData(obj);
    }
  }

  render() {
    const finalCustomJSON = manipulateCustomJSONOne(
      this.props.customJSON,
      this.props.isEdit,
      this.props.formRowData,
      this.props.fieldMapIndex,
      this.props.products,
      this.props.unusedProducts,
    );
    const heading = this.props.isEdit
      ? `Update product in ${this.props.pricebookName} price book`
      : `Add new product to ${this.props.pricebookName} price book`;
    const subHeading = this.props.isEdit
      ? ""
      : `Select product and configure price`;
    return (
      <div className="pricingmethodwrapper-wrapper">
        <div className="pricingmethod-title">
          <span className="pricingmethodwrapper-header">{heading}</span>
          <span className="pricingmethodwrapper-subheader">{subHeading}</span>
        </div>
        {finalCustomJSON.map(formField => (
          <FormField
            {...formField}
            isEdit={this.props.isEdit}
            {...this.props}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    products,
    unusedProducts,
    props,
    metaData,
    columnDefs,
    customColumnDefs,
    formRowData,
  } = state.PricebookStore;
  return {
    products,
    unusedProducts,
    props,
    fieldMapIndex: metaData.fieldMapIndex,
    columnDefs,
    customColumnDefs,
    formRowData,
  };
};

const mapDispatchToProps = {
  updatePricebookData,
  updateFormRowData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricebookItemEditor);
